import { useQuery } from 'react-query';
import { albumResponse } from 'src/models/gallery';
import { fetchAlbum } from 'src/services/gallery';

export default function useGetALbum(id: number) {
  return useQuery<albumResponse>(['album', id], () =>
    id != 0 ? fetchAlbum(id) : null
  );
}
